import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Briefcase,Database, Layers, ShoppingBag, ShoppingCart, Globe, Search, ChevronLeft, ChevronRight  } from 'lucide-react';
import { API_SUCCESS_RESPONSE_CODE,API_SUCCESS_RESPONSE_CREATED_CODE } from "../../utils/config_mapping";
import PageLoader from '../common/pageloader';
import {getLicensorDataExploerView,getDataExplorerDetails,getDataExplorerPortfolio} from "../../services/admin"
import $ from "jquery";
import { hasPageAccess,accessDenied } from "../../utils/page_access"; // Import
import Multiselect from 'multiselect-react-dropdown';
import { CommonMultiSelect } from '../common/MultiSelect';
import HeaderLogo  from "../structure/headerlogo";


/**
 * Portfolio
 * Portfolio Data Explorer page component.
 * - Fetches portfolio and licensor dimension data
 * - Provides multiselect filters for licensors/properties/products/channels/territories
 * - Builds and displays valid combinations and supports export and pagination
 */
export const Portfolio = () => {

    const [tab1, setTab1] = useState({
    portfolioData: [], // Full portfolio
    licensors: [],
    properties: [],
    products: [],
    channels: [],
    territories: [],
    selectedLicensors: [],
    selectedProperties: [],
    selectedProducts: [],
    selectedChannels: [],
    selectedTerritories: []
  });



  //let pageName = "Data Explorer";

  let pageName = "Data Explorer Portfolio";


  const [tab1selectedLicensors, settab1SelectedLicensors] = useState([]);
  const [tab1selectedProperties, settab1SelectedProperties] = useState([]);
  const [tab1selectedChannels, settab1SelectedChannels] = useState([]);
  const [tab1selectedTerritories, settab1SelectedTerritories] = useState([]);

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]); // This will hold the API response
  const [tabportfoliodata, setTabPortFolioData] = useState([]); // This will hold the API response
 const  [tabportfoliolicensordata, setTabPortFolioLicensorData] = useState([]); // This will hold the API response


  const [tableData, setTableData] = useState([]); // State to hold API data
  
  // Options for filters returned by the tableData response
  const [productOptions, setProductOptions] = useState([]);
  const [channelOptions, setChannelOptions] = useState([]);
  const [territoryOptions, setTerritoryOptions] = useState([]);
    
  const [fileName, setFileName] = useState("");
  const [property, setProperty] = useState("");
    
  const [category, setCategory] = useState("");
  const [channel, setChannel] = useState("");
  const [territory, setTerritory] = useState("");

  
  const [view, setView] = useState('dimension');
  const [step, setStep] = useState(1);
  const [licensors, setLicensors] = useState([]);
  const [properties, setProperties] = useState([]);
  const [products, setProducts] = useState([]);
  const [channels, setChannels] = useState([]);
  const [territories, setTerritories] = useState([]);
  const [combinations, setCombinations] = useState([]);

  const [selectedLicensor, setSelectedLicensor] = useState(null);
  const [selectedProperties, setSelectedProperties] = useState([]);

  const [licensorFilter, setLicensorFilter] = useState('');
  const [propertyFilter, setPropertyFilter] = useState('');
  const [productFilters, setProductFilters] = useState({ l1: '', l2: '', l3: '' });
  const [channelFilters, setChannelFilters] = useState({ l1: '', l2: '', l3: '' });
  const [territoryFilters, setTerritoryFilters] = useState({ l1: '', l2: '' });

  const [combinationFilters, setCombinationFilters] = useState({
    productL1: 'All',
    productL2: 'All',
    productL3: 'All',
    channelL1: 'All',
    channelL2: 'All',
    channelL3: 'All',
    territoryL1: 'All',
    territoryL2: 'All',
  });
  const [combinationSearch, setCombinationSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 50;


    /**
     * handleLicensorSelect
     * Callback for licensor multiselect to update selected licensors state.
     * @param {Array} selectedList - Selected licensor items
     */
    const handleLicensorSelect = (selectedList) => {
      settab1SelectedLicensors(selectedList);
    };

  /**
   * handlePropertiesSelect
   * Callback for properties multiselect to update selected properties state.
   * @param {Array} selectedList - Selected property items
   */
  const handlePropertiesSelect = (selectedList) => {
    settab1SelectedProperties(selectedList);
  };


  // Handle undefined safely
  const licensors_tabportfolio = tabportfoliodata?.licensor || [];
  const productsportfolio = tabportfoliodata?.product || [];

  // useEffect(() => {
  //   console.log("Selected Licensors:", selectedLicensors);
  //   console.log("Selected Products:", selectedProducts);
  // }, [tab1selectedLicensors, selectedProducts]);



  const filteredLicensors = licensors.filter(l =>
    l.name.toLowerCase().includes(licensorFilter.toLowerCase())
  );

  const filteredProperties = properties.filter(p =>
    p.name.toLowerCase().includes(propertyFilter.toLowerCase())
  );

  const uniqueProducts = {
    level1: [...new Set(products.map(p => p.level1))],
    level2: [...new Set(products.map(p => p.level2))],
    level3: [...new Set(products.map(p => p.level3))],
  };

  const uniqueChannels = {
    level1: [...new Set(channels.map(c => c.level1))],
    level2: [...new Set(channels.map(c => c.level2))],
    level3: [...new Set(channels.map(c => c.level3))],
  };

  const uniqueTerritories = {
    level1: [...new Set(territories.map(t => t.level1))],
    level2: [...new Set(territories.map(t => t.level2))],
  };

  const filteredProducts = products.filter(p =>
    p.level1.toLowerCase().includes(productFilters.l1.toLowerCase()) &&
    p.level2.toLowerCase().includes(productFilters.l2.toLowerCase()) &&
    p.level3.toLowerCase().includes(productFilters.l3.toLowerCase())
  );

  const filteredChannels = channels.filter(c =>
    c.level1.toLowerCase().includes(channelFilters.l1.toLowerCase()) &&
    c.level2.toLowerCase().includes(channelFilters.l2.toLowerCase()) &&
    c.level3.toLowerCase().includes(channelFilters.l3.toLowerCase())
  );

  const filteredTerritories = territories.filter(t =>
    t.level1.toLowerCase().includes(territoryFilters.l1.toLowerCase()) &&
    t.level2.toLowerCase().includes(territoryFilters.l2.toLowerCase())
  );

  /**
   * processApiData
   * Transform raw API response into UI-friendly structures (licensors and properties).
   * @param {Array} apiData - Raw API array
   * @returns {{processedLicensors: Array, allProperties: Array}}
   */
  const processApiData = (apiData) => {
    const processedLicensors = apiData.map(item => ({
      id: item.label, // Using label as ID since it's unique
      name: item.label,
      property_count: item.propertyType.length
    })).sort((a, b) => a.name.localeCompare(b.name));

    // Extract all properties from all licensors
    const allProperties = [];
    apiData.forEach(licensor => {
      licensor.propertyType.forEach(property => {
        allProperties.push({
          id: `${licensor.label}_${property}`, // Create unique ID
          licensor_id: licensor.label,
          name: property
        });
      });
    });

    return { processedLicensors, allProperties };
  };

  

   
  /**
   * fetchDataTab1
   * Fetch portfolio data (combinations/options) using current tab1 selections.
   * Accepts an optional `selections` snapshot to avoid stale-state issues.
   * @param {object|null} selections - Optional state snapshot to use for request
   */
  const fetchDataTab1 = async (selections = null) => {
    // If caller provided a selections object use it, otherwise use current tab1 state
    const sel = selections || tab1;

    $(".page_pro_load").hide();
    setLoading(true);
    try {

      // Build request payload using names (not option objects)
      const obj = {
        licensor: (sel.selectedLicensors || []).map(s => s.name),
        propertyType: (sel.selectedProperties || []).map(s => s.name),
        productL1: (sel.selectedProductL1 || []).map(s => s.name),
        productL2: (sel.selectedProductL2 || []).map(s => s.name),
        productL3: (sel.selectedProductL3 || []).map(s => s.name),
        channelsL1: (sel.selectedChannelL1 || []).map(s => s.name),
        channelsL2: (sel.selectedChannelL2 || []).map(s => s.name),
        channelsL3: (sel.selectedChannelL3 || []).map(s => s.name),
        territoriesL1: (sel.selectedTerritoryL1 || []).map(s => s.name),
        territoriesL2: (sel.selectedTerritoryL2 || []).map(s => s.name)
      };

      const result = await getDataExplorerPortfolio(obj);
      if (result.code === API_SUCCESS_RESPONSE_CODE) {
        setTabPortFolioData(result.data);

        const data = result.data;

        const licensorOptions = (data.licensor || []).map((name, index) => ({
          name: name,
          id: `licensor_${index + 1}`
        }));

        const propertyOptions = (data.Properties || []).map((name, index) => ({
          name: name,
          id: `property_${index + 1}`
        }));

        const productL1Options = (data.product?.productL1 || []).map((name, index) => ({
          name: name,
          id: `productL1_${index + 1}`
        }));
        const productL2Options = (data.product?.productL2 || []).map((name, index) => ({
          name: name,
          id: `productL2_${index + 1}`
        }));
        const productL3Options = (data.product?.productL3 || []).map((name, index) => ({
          name: name,
          id: `productL3_${index + 1}`
        }));
        const productCombined = data.product?.combined || [];

        const channelL1Options = (data.channels?.channelsL1 || []).map((name, index) => ({
          name: name,
          id: `channelL1_${index + 1}`
        }));
        const channelL2Options = (data.channels?.channelsL2 || []).map((name, index) => ({
          name: name,
          id: `channelL2_${index + 1}`
        }));
        const channelL3Options = (data.channels?.channelsL3 || []).map((name, index) => ({
          name: name,
          id: `channelL3_${index + 1}`
        }));
        const channelCombined = data.channels?.combined || [];

        const territoryL1Options = (data.territories?.territoriesL1 || []).map((name, index) => ({
          name: name,
          id: `territoryL1_${index + 1}`
        }));
        const territoryL2Options = (data.territories?.territoriesL2 || []).map((name, index) => ({
          name: name,
          id: `territoryL2_${index + 1}`
        }));
        const territoryCombined = data.territories?.combined || [];

        // Update options and combined lists but DO NOT clear the current selected* arrays.
        // This preserves selections passed via `selections` or already set in state.
        setTab1(prev => ({
          ...prev,
          portfolioData: data,
          licensors: licensorOptions,
          properties: propertyOptions,
          products: productL1Options,
          channels: channelL1Options,
          territories: territoryL1Options,
          productL1Options,
          productL2Options,
          productL3Options,
          productCombined,
          channelL1Options,
          channelL2Options,
          channelL3Options,
          channelCombined,
          territoryL1Options,
          territoryL2Options,
          territoryCombined
          // note: do NOT reset selected* here
        }));

        setTabPortFolioLicensorData(data.licensor);
      } else {
        console.warn("Unexpected response status:", result.status);
        setTab1(prev => ({ ...prev, portfolioData: [] }));
      }
    } catch (error) {
      console.error("Error fetching portfolio data:", error);
      setTab1(prev => ({ ...prev, portfolioData: [] }));
    } finally {
      setLoading(false);
    }
  };



  /**
   * fetchDataTab2
   * Fetch licensor/dimension view data and populate licensors/properties for the dimension explorer.
   */
  const fetchDataTab2 = async () => {
    $(".page_pro_load").hide();
    setLoading(true);
    try {
      const result = await getLicensorDataExploerView();
      if (result.code === API_SUCCESS_RESPONSE_CODE) {
        setData(result.data);
        
        // Process the API data
        const { processedLicensors, allProperties } = processApiData(result.data);
        
        // Set processed data
        setLicensors(processedLicensors);
        setProperties(allProperties);
      } else {
        console.warn("Unexpected response status:", result.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      trackError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    //fetchDataTab2();
    fetchDataTab1();
  }, []);


    // ----------------------------- SELECTION HANDLERS -----------------------------
    /**
     * handleSelect
     * Generic selection handler for multiselect controls that updates `tab1`.
     * Clears dependent selections when licensors change and triggers a data refresh.
     * @param {string} key - State key to update (e.g., 'selectedLicensors')
     * @param {Array} selectedList - Selected items
     */
    const handleSelect = (key, selectedList) => {
  // Ensure no duplicate values in selectedList
  const uniqueList = Array.from(new Set(selectedList));

  // Build a new tab1 state snapshot with the updated selection
  const newTab = {
    ...tab1,
    [key]: uniqueList,
  };

  // If the user changed licensors, clear dependent selections
  if (key === 'selectedLicensors') {
    newTab.selectedProperties = [];
    newTab.selectedProductL1 = [];
    newTab.selectedProductL2 = [];
    newTab.selectedProductL3 = [];
    newTab.selectedChannelL1 = [];
    newTab.selectedChannelL2 = [];
    newTab.selectedChannelL3 = [];
    newTab.selectedTerritoryL1 = [];
    newTab.selectedTerritoryL2 = [];
  }

  // Persist new state and fetch using the new snapshot (avoids stale state)
  setTab1(newTab);
  setCurrentPage(1);
  fetchDataTab1(newTab);
};


  // ----------------------------- PORTFOLIO COMBINATION FILTER -----------------------------
  /**
   * getFilteredPortfolio
   * Apply current `tab1` selection filters to the portfolioData.
   * @returns {Array} Filtered portfolio items
   */
  const getFilteredPortfolio = () => {
    const { portfolioData, selectedLicensors, selectedProperties, selectedProducts, selectedChannels, selectedTerritories } = tab1;
    if (!Array.isArray(portfolioData)) return [];
    return portfolioData.filter(item => {
      const licensorMatch = selectedLicensors.length ? selectedLicensors.some(l => l.name === item.licensor) : true;
      const propertyMatch = selectedProperties.length ? selectedProperties.some(p => p.name === item.property) : true;
      const productMatch = selectedProducts.length ? selectedProducts.some(pr => item.products.includes(pr.name)) : true;
      const channelMatch = selectedChannels.length ? selectedChannels.some(ch => item.channels.includes(ch.name)) : true;
      const territoryMatch = selectedTerritories.length ? selectedTerritories.some(t => item.territories.includes(t.name)) : true;
      return licensorMatch && propertyMatch && productMatch && channelMatch && territoryMatch;
    });
  };

    const filteredPortfolio = getFilteredPortfolio();


           /**
            * getDataExplorerDetail
            * Fetch detailed combination/exception data for a licensor+properties selection.
            * @param {object} data - Request payload containing licensor and propertyType
            */
           const getDataExplorerDetail = async (data) => {
               // alert(JSON.stringify(data))
        
               // $(".page_pro_load").hide();
               // setLoading(true); // Stop loading spinner
                try {
                  const result = await getDataExplorerDetails(data);
                  if (result.code === API_SUCCESS_RESPONSE_CODE) {
                    // store API response object which contains product/channel/territory arrays and 'data' array
                    setTableData(result.data || {});
                    setProductOptions(result.data?.product || []);
                    setChannelOptions(result.data?.channel || []);
                    setTerritoryOptions(result.data?.territory || []);
                  } else {
                    console.warn("Unexpected response status:", result.status);
                  }
                } catch (error) {
                  console.error("Error fetching data:", error);
                }
                finally {
                   setLoading(false); // Stop loading spinner
               }
              };


  // Update the licensorProperties calculation to work with API data
  const licensorProperties = properties.filter(p =>
    selectedLicensor ? p.licensor_id === selectedLicensor.id : false
  );

  /**
   * toggleProperty
   * Toggle a property name in the `selectedProperties` array.
   * @param {string} propertyName
   */
  const toggleProperty = (propertyName) => {
    if (selectedProperties.includes(propertyName)) {
      setSelectedProperties(selectedProperties.filter(p => p !== propertyName));
    } else {
      setSelectedProperties([...selectedProperties, propertyName]);
    }
  };

  /**
   * getRelevantCombinations
   * Build combination rows from `tableData` for the currently selected properties.
   * Falls back to static `combinations` if no API table data exists.
   * @returns {Array} Combination objects
   */
  const getRelevantCombinations = () => {
    // Check if we have tableData from the API
    if (tableData && tableData.data && Array.isArray(tableData.data)) {
      const apiCombinations = [];
      let combinationId = 0;

      // Process each data item from the API response
      tableData.data.forEach((item, itemIndex) => {
        const productL1 = item["Product Category (L1)"] || '';
        const productL2 = item["Product SubCategory (L2)"] || '';
        const channelL1 = item["Channel (L1)"] || '';
        const channelL2 = item["Channel SubType (L2)"] || '';
        const territoryL1 = item["Territory (L1)"] || '';
        const territoryL2 = item["Territory Zone (L2)"] || '';
        
        const productL3Array = item["Product (L3)"] || [];
        const channelL3Array = item["Channel (L3)"] || [];

        // If no Channel (L3) array, create a single entry with empty channel L3
        const channelsToProcess = channelL3Array.length > 0 ? channelL3Array : [''];

        // Create combinations for each Product L3 x Channel L3 combination
        productL3Array.forEach(productL3 => {
          channelsToProcess.forEach(channelL3 => {
            // Create combination for each selected property
            selectedProperties.forEach(property => {
              apiCombinations.push({
                id: `api_${combinationId++}`,
                property: property,
                product_l1: productL1,
                product_l2: productL2,
                product_l3: productL3,
                channel_l1: channelL1,
                channel_l2: channelL2,
                channel_l3: channelL3,
                territory_l1: territoryL1,
                territory_l2: territoryL2,
                restrictions: '' // No restrictions data in this API response
              });
            });
          });
        });
      });

      return apiCombinations;
    }

    // Fallback to static combinations if no API data
    return combinations.filter(c => 
      selectedProperties.length ? selectedProperties.includes(c.property) : true
    );
  };

  const filteredCombinations = getRelevantCombinations().filter(c => {
    const matchesFilters =
      (combinationFilters.productL1 === 'All' || c.product_l1 === combinationFilters.productL1) &&
      (combinationFilters.productL2 === 'All' || c.product_l2 === combinationFilters.productL2) &&
      (combinationFilters.productL3 === 'All' || c.product_l3 === combinationFilters.productL3) &&
      (combinationFilters.channelL1 === 'All' || c.channel_l1 === combinationFilters.channelL1) &&
      (combinationFilters.channelL2 === 'All' || c.channel_l2 === combinationFilters.channelL2) &&
      (combinationFilters.channelL3 === 'All' || c.channel_l3 === combinationFilters.channelL3) &&
      (combinationFilters.territoryL1 === 'All' || c.territory_l1 === combinationFilters.territoryL1) &&
      (combinationFilters.territoryL2 === 'All' || c.territory_l2 === combinationFilters.territoryL2);

    const matchesSearch = combinationSearch === '' ||
      Object.values(c).some(val =>
        String(val).toLowerCase().includes(combinationSearch.toLowerCase())
      );

    return matchesFilters && matchesSearch;
  });

 

  const totalPages = Math.ceil(filteredCombinations.length / rowsPerPage);
  const paginatedCombinations = filteredCombinations.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const uniqueCombinationValues = {
    productL1: ['All', ...new Set(getRelevantCombinations().map(c => c.product_l1))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    productL2: ['All', ...new Set(getRelevantCombinations().map(c => c.product_l2))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    productL3: ['All', ...new Set(getRelevantCombinations().map(c => c.product_l3))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    channelL1: ['All', ...new Set(getRelevantCombinations().map(c => c.channel_l1))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    channelL2: ['All', ...new Set(getRelevantCombinations().map(c => c.channel_l2))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    channelL3: ['All', ...new Set(getRelevantCombinations().map(c => c.channel_l3))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    territoryL1: ['All', ...new Set(getRelevantCombinations().map(c => c.territory_l1))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    territoryL2: ['All', ...new Set(getRelevantCombinations().map(c => c.territory_l2))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
  };

  // Add helper functions here
  /**
   * getFilteredProductL2Options
   * Compute Product L2 choices constrained by current Product L1 selection.
   * @returns {Array<string>}
   */
  const getFilteredProductL2Options = () => {
  if (combinationFilters.productL1 === 'All') {
    return uniqueCombinationValues.productL2;
  }
  const relevantCombinations = getRelevantCombinations();
  const filteredOptions = ['All', ...new Set(
    relevantCombinations
      .filter(c => c.product_l1 === combinationFilters.productL1)
      .map(c => c.product_l2)
  )].sort((a, b) => {
    if (a === 'All') return -1;
    if (b === 'All') return 1;
    return a.localeCompare(b);
  });
  return filteredOptions;
};

/**
 * getFilteredProductL3Options
 * Compute Product L3 choices constrained by Product L1/L2 selections.
 * @returns {Array<string>}
 */
const getFilteredProductL3Options = () => {
  if (combinationFilters.productL1 === 'All' && combinationFilters.productL2 === 'All') {
    return uniqueCombinationValues.productL3;
  }
  const relevantCombinations = getRelevantCombinations();
  const filteredOptions = ['All', ...new Set(
    relevantCombinations
      .filter(c => 
        (combinationFilters.productL1 === 'All' || c.product_l1 === combinationFilters.productL1) &&
        (combinationFilters.productL2 === 'All' || c.product_l2 === combinationFilters.productL2)
      )
      .map(c => c.product_l3)
  )].sort((a, b) => {
    if (a === 'All') return -1;
    if (b === 'All') return 1;
    return a.localeCompare(b);
  });
  return filteredOptions;
};

/**
 * getFilteredChannelL2Options
 * Compute Channel L2 choices constrained by current Channel L1 selection.
 * @returns {Array<string>}
 */
const getFilteredChannelL2Options = () => {
  if (combinationFilters.channelL1 === 'All') {
    return uniqueCombinationValues.channelL2;
  }
  const relevantCombinations = getRelevantCombinations();
  const filteredOptions = ['All', ...new Set(
    relevantCombinations
      .filter(c => c.channel_l1 === combinationFilters.channelL1)
      .map(c => c.channel_l2) // Fixed: was c.channelL2, should be c.channel_l2
  )].sort((a, b) => {
    if (a === 'All') return -1;
    if (b === 'All') return 1;
    return a.localeCompare(b);
  });
  return filteredOptions;
};

/**
 * getFilteredChannelL3Options
 * Compute Channel L3 choices constrained by Channel L1/L2 selections.
 * @returns {Array<string>}
 */
const getFilteredChannelL3Options = () => {
  if (combinationFilters.channelL1 === 'All' && combinationFilters.channelL2 === 'All') {
    return uniqueCombinationValues.channelL3;
  }
  const relevantCombinations = getRelevantCombinations();
  const filteredOptions = ['All', ...new Set(
    relevantCombinations
      .filter(c => 
        (combinationFilters.channelL1 === 'All' || c.channel_l1 === combinationFilters.channelL1) &&
        (combinationFilters.channelL2 === 'All' || c.channel_l2 === combinationFilters.channelL2)
      )
      .map(c => c.channel_l3)
  )].sort((a, b) => {
    if (a === 'All') return -1;
    if (b === 'All') return 1;
    return a.localeCompare(b);
  });
  return filteredOptions;
};

/**
 * getFilteredTerritoryL2Options
 * Compute Territory L2 choices constrained by current Territory L1 selection.
 * @returns {Array<string>}
 */
const getFilteredTerritoryL2Options = () => {
  if (combinationFilters.territoryL1 === 'All') {
    return uniqueCombinationValues.territoryL2;
  }
  const relevantCombinations = getRelevantCombinations();
  const filteredOptions = ['All', ...new Set(
    relevantCombinations
      .filter(c => c.territory_l1 === combinationFilters.territoryL1)
      .map(c => c.territory_l2)
  )].sort((a, b) => {
    if (a === 'All') return -1;
    if (b === 'All') return 1;
    return a.localeCompare(b);
  });
  return filteredOptions;
};

// Add these handler functions
const handleProductL1Change = (value) => {
  setCombinationFilters({
    ...combinationFilters,
    productL1: value,
    productL2: 'All', // Reset dependent filters
    productL3: 'All'
  });
  setCurrentPage(1);
};

const handleProductL2Change = (value) => {
  setCombinationFilters({
    ...combinationFilters,
    productL2: value,
    productL3: 'All' // Reset dependent filter
  });
  setCurrentPage(1);
};

const handleChannelL1Change = (value) => {
  setCombinationFilters({
    ...combinationFilters,
    channelL1: value,
    channelL2: 'All', // Reset dependent filters
    channelL3: 'All'
  });
  setCurrentPage(1);
};

const handleChannelL2Change = (value) => {
  setCombinationFilters({
    ...combinationFilters,
    channelL2: value,
    channelL3: 'All' // Reset dependent filter
  });
  setCurrentPage(1);
};

const handleTerritoryL1Change = (value) => {
  setCombinationFilters({
    ...combinationFilters,
    territoryL1: value,
    territoryL2: 'All' // Reset dependent filter
  });
  setCurrentPage(1);
};

  // Add loading state to the render
 

  return (
    <div className="main-content" style={{ paddingTop: 64 }}>
       <HeaderLogo />
      <div className="page-content">
        <div className="container-fluid">
          <div className="mb-4">
            <div className="d-flex align-items-center mb-2">
              <div className="bg-primary text-white rounded p-2 me-3">
                <Briefcase size={24} />
              </div>
              <div>
                <h1 className="h3 mb-0 fw-bold">Portfolio Data Explorer</h1>
                <p className="text-muted mb-0 small">Explore licensing data across different dimensions</p>
              </div>
            </div>
          </div>

           {loading ? 
            <PageLoader /> : 
          hasPageAccess(pageName, "view") === false ? accessDenied() : 
          (
          <>    
          {view === 'dimension' && (
            <div className="row g-4">

              <div className="card h-100 shadow-sm" 
              // style={{ position: 'sticky', top: '72px', zIndex: 1020, background: 'white', alignSelf: 'flex-start' }}
              >
                <div className="card-body">

                  <div className="mb-3">
                    <div className="fw-semibold mb-2 d-flex align-items-center">
                      <span className="me-2">🔍</span> Filters
                    </div>
                    <div className="row g-2 mb-1">
                      <div className="col-md-3">
                        <label className="form-label small">Licensor</label>
                        <CommonMultiSelect
                          options={tab1.licensors || []}
                          selectedValues={tab1.selectedLicensors || []}
                          onSelect={(selectedList) => handleSelect("selectedLicensors", selectedList)}
                          onRemove={(selectedList) => handleSelect("selectedLicensors", selectedList)}
                          displayValue="name"
                          placeholder="Filter Licensors"
                        />

                      </div>
                      <div className="col-md-3">
                        <label className="form-label small">Properties</label>
                        <CommonMultiSelect
                          options={tab1.properties || []}
                          selectedValues={tab1.selectedProperties || []}
                          onSelect={(selectedList) => handleSelect('selectedProperties', selectedList)}
                          onRemove={(selectedList) => handleSelect('selectedProperties', selectedList)}
                          displayValue="name"
                          placeholder="Filter Properties"
                          showCheckbox
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small">Product L1</label>

                        <CommonMultiSelect
                          options={tab1.productL1Options || []}
                          selectedValues={tab1.selectedProductL1 || []}
                          onSelect={(selectedList) => handleSelect('selectedProductL1', selectedList)}
                          onRemove={(selectedList) => handleSelect('selectedProductL1', selectedList)}
                          displayValue="name"
                          placeholder="Product L1"
                          showCheckbox
                          style={{
                            chips: { background: 'rgba(137, 101, 240, 0.75)' },
                            searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                            optionContainer: { borderRadius: '8px' },
                          }}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small">Product L2</label>

                        <CommonMultiSelect
                          options={tab1.productL2Options || []}
                          selectedValues={tab1.selectedProductL2 || []}
                          onSelect={(selectedList) => handleSelect('selectedProductL2', selectedList)}
                          onRemove={(selectedList) => handleSelect('selectedProductL2', selectedList)}
                          displayValue="name"
                          placeholder="Product L2"
                          showCheckbox
                          style={{
                            chips: { background: 'rgba(137, 101, 240, 0.75)' },
                            searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                            optionContainer: { borderRadius: '8px' },
                          }}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small">Product L3</label>
                        <CommonMultiSelect
                          options={tab1.productL3Options || []}
                          selectedValues={tab1.selectedProductL3 || []}
                          onSelect={(selectedList) => handleSelect('selectedProductL3', selectedList)}
                          onRemove={(selectedList) => handleSelect('selectedProductL3', selectedList)}
                          displayValue="name"
                          placeholder="Product L3"
                          showCheckbox
                          style={{
                            chips: { background: 'rgba(137, 101, 240, 0.75)' },
                            searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                            optionContainer: { borderRadius: '8px' },
                          }}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small">Channel L1</label>
                        <CommonMultiSelect
                          options={tab1.channelL1Options || []}
                          selectedValues={tab1.selectedChannelL1 || []}
                          onSelect={(selectedList) => handleSelect('selectedChannelL1', selectedList)}
                          onRemove={(selectedList) => handleSelect('selectedChannelL1', selectedList)}
                          displayValue="name"
                          placeholder="Channel L1"
                          showCheckbox
                          style={{
                            chips: { background: 'rgba(137, 101, 240, 0.75)' },
                            searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                            optionContainer: { borderRadius: '8px' },
                          }}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small">Channel L2</label>
                        <CommonMultiSelect
                          options={tab1.channelL2Options || []}
                          selectedValues={tab1.selectedChannelL2 || []}
                          onSelect={(selectedList) => handleSelect('selectedChannelL2', selectedList)}
                          onRemove={(selectedList) => handleSelect('selectedChannelL2', selectedList)}
                          displayValue="name"
                          placeholder="Channel L2"
                          showCheckbox
                          style={{
                            chips: { background: 'rgba(137, 101, 240, 0.75)' },
                            searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                            optionContainer: { borderRadius: '8px' },
                          }}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small">Channel L3</label>
                        <CommonMultiSelect
                          options={tab1.channelL3Options || []}
                          selectedValues={tab1.selectedChannelL3 || []}
                          onSelect={(selectedList) => handleSelect('selectedChannelL3', selectedList)}
                          onRemove={(selectedList) => handleSelect('selectedChannelL3', selectedList)}
                          displayValue="name"
                          placeholder="Channel L3"
                          showCheckbox
                          style={{
                            chips: { background: 'rgba(137, 101, 240, 0.75)' },
                            searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                            optionContainer: { borderRadius: '8px' },
                          }}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small">Territory L1</label>
                        <CommonMultiSelect
                          options={tab1.territoryL1Options || []}
                          selectedValues={tab1.selectedTerritoryL1 || []}
                          onSelect={(selectedList) => handleSelect('selectedTerritoryL1', selectedList)}
                          onRemove={(selectedList) => handleSelect('selectedTerritoryL1', selectedList)}
                          displayValue="name"
                          placeholder="Territory L1"
                          showCheckbox
                          style={{
                            chips: { background: 'rgba(137, 101, 240, 0.75)' },
                            searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                            optionContainer: { borderRadius: '8px' },
                          }}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small">Territory L2</label>
                        <CommonMultiSelect
                          options={tab1.territoryL2Options || []}
                          selectedValues={tab1.selectedTerritoryL2 || []}
                          onSelect={(selectedList) => handleSelect('selectedTerritoryL2', selectedList)}
                          onRemove={(selectedList) => handleSelect('selectedTerritoryL2', selectedList)}
                          displayValue="name"
                          placeholder="Territory L2"
                          showCheckbox
                          style={{
                            chips: { background: 'rgba(137, 101, 240, 0.75)' },
                            searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                            optionContainer: { borderRadius: '8px' },
                          }}
                        />
                      </div>
<div className="col-md-6 d-flex justify-content-end">
  <button
    style={{ marginTop: '25px',height:"25px" }}
    className="btn btn-outline-primary btn-sm"
    onClick={() => {

      // Clear all selections
      const clearedTab = {
        ...tab1,
        selectedLicensors: [],
        selectedProperties: [],
        selectedProductL1: [],
        selectedProductL2: [],  
        selectedProductL3: [],
        selectedChannelL1: [],
        selectedChannelL2: [],    
        selectedChannelL3: [],
        selectedTerritoryL1: [],
        selectedTerritoryL2: []   
      }
      setTab1(clearedTab);
      fetchDataTab1();
    }}
  >
    Clear All
  </button>
</div>


                    </div>
                  </div>
                  
               <div className="small text-muted d-none">
  {[
    {
      label: 'Licensor',
      values: tab1.selectedLicensors,
    },
    {
      label: 'Properties',
      values: tab1.selectedProperties,
    },
    {
      label: 'Product L1',
      values: tab1.selectedProductL1,
    },
    {
      label: 'Product L2',
      values: tab1.selectedProductL2,
    },
    {
      label: 'Product L3',
      values: tab1.selectedProductL3,
    },
    {
      label: 'Channel L1',
      values: tab1.selectedChannelL1,
    },
    {
      label: 'Channel L2',
      values: tab1.selectedChannelL2,
    },
    {
      label: 'Channel L3',
      values: tab1.selectedChannelL3,
    },
  ]
    .filter(item => item.values && item.values.length > 0)
    .map((item, index, array) => (
      <React.Fragment key={item.label}>
        {item.label}:{' '}
        <span className="fw-semibold">
          {item.values.map(v => v.name).join(', ')}
        </span>
        {index < array.length - 1 && <>{'\u00A0'}|{'\u00A0'}</>}
      </React.Fragment>
    ))}
</div>


                
                </div>
              </div>

              {/* Licensors Panel */}
    <div className="col-md-3">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <Database size={20} className="text-primary me-2" />
              <h5 className="mb-0 fw-bold">Licensors</h5>
            </div>
            <span className="badge bg-primary rounded-pill">{tab1.selectedLicensors.length}</span>
          </div>
             
        {/* <Multiselect
  options={tab1.licensors || []}
  selectedValues={tab1.selectedLicensors || []}
  onSelect={(selectedList) => handleSelect('selectedLicensors', selectedList)}
  onRemove={(selectedList) => handleSelect('selectedLicensors', selectedList)}
  displayValue="name"
  placeholder="Filter Licensors"
  showCheckbox
/> */}


          {/* <div className="small text-muted mt-2 mb-2 fw-semibold">
            {tab1.selectedLicensors.length > 0 ? '\u00A0' : 'All Licensors'}
          </div> */}
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {tab1.selectedLicensors.length > 0 ? (
              // Show selected licensors when filtered
              tab1.selectedLicensors.map((licensor) => (
                <div key={licensor.id} className="border-bottom py-2 small">
                  {licensor.name}
                </div>
              ))
            ) : (
              // Show all licensors by default
              (tab1.licensors || []).map((licensor) => (
                <div key={licensor.id} className="border-bottom py-2 small text-muted">
                  {licensor.name}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>

    {/* Properties Panel */}
    <div className="col-md-3">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <Layers size={20} className="text-primary me-2" />
              <h5 className="mb-0 fw-bold">Properties</h5>
            </div>
            <span className="badge bg-primary rounded-pill">{tab1.selectedProperties.length}</span>
          </div>
          {/* <Multiselect
  options={tab1.properties || []}
  selectedValues={tab1.selectedProperties || []}
  onSelect={(selectedList) => handleSelect('selectedProperties', selectedList)}
  onRemove={(selectedList) => handleSelect('selectedProperties', selectedList)}
  displayValue="name"
  placeholder="Filter Properties"
  showCheckbox
/> */}



          {/* <div className="small text-muted mt-2 mb-2 fw-semibold">
            {tab1.selectedProperties.length > 0 ? '\u00A0' : 'All Properties'}
          </div> */}
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {tab1.selectedProperties.length > 0 ? (
              // Show selected properties when filtered
              tab1.selectedProperties.map((property) => (
                <div key={property.id} className="border-bottom py-2 small">
                  
                  {property.name}
                </div>
              ))
            ) : (
              // Show all properties by default
              (tab1.properties || []).map((property) => (
                <div key={property.id} className="border-bottom py-2 small text-muted">
                  {property.name}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>

    {/* Products Panel */}
    <div className="col-md-6">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <ShoppingBag size={20} className="text-primary me-2" />
              <h5 className="mb-0 fw-bold">Products</h5>
            </div>
            <span className="badge bg-primary rounded-pill">
              {(tab1.selectedProductL1?.length || 0) + (tab1.selectedProductL2?.length || 0) + (tab1.selectedProductL3?.length || 0)}
            </span>
          </div>

          <div className="row g-2 mb-3">
            <div className="col-4">
             
             
            </div>
            <div className="col-4">
              
              
            </div>
            <div className="col-4">
           
              
            </div>
          </div>
        <div className="small text-muted mb-2 fw-semibold">
            {/* {(tab1.selectedProductL1?.length > 0 || tab1.selectedProductL2?.length > 0 || tab1.selectedProductL3?.length > 0) ? '\u00A0' : 'All Products'} */}
          </div>          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {(tab1.productCombined || []).map((t, i) => (
                  <div key={`tc_${i}`} className="border-bottom py-1 small text-muted">
                    {t}
                  </div>
                ))}
          </div>
        </div>
      </div>
    </div>

    {/* Channels Panel */}
    <div className="col-md-6">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <ShoppingCart size={20} className="text-primary me-2" />
              <h5 className="mb-0 fw-bold">Channels</h5>
            </div>
            <span className="badge bg-primary rounded-pill">
              {(tab1.selectedChannelL1?.length || 0) + (tab1.selectedChannelL2?.length || 0) + (tab1.selectedChannelL3?.length || 0)}
            </span>
          </div>

          <div className="row g-2 mb-3">
            <div className="col-4">
             
              
            </div>
            <div className="col-4">
             
              
            </div>
            <div className="col-4">
              
             
            </div>
          </div>

          <div className="small text-muted mb-2 fw-semibold">
            {/* {(tab1.selectedChannelL1?.length > 0 || tab1.selectedChannelL2?.length > 0 || tab1.selectedChannelL3?.length > 0) ? '\u00A0' : 'All Channels'} */}
          </div>
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
           {(tab1.channelCombined || []).map((t, i) => (
                  <div key={`tc_${i}`} className="border-bottom py-1 small text-muted">
                    {t}
                  </div>
                ))}
          </div>
        </div>
      </div>
    </div>

    {/* Territories Panel */}
    <div className="col-md-6">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <Globe size={20} className="text-primary me-2" />
              <h5 className="mb-0 fw-bold">Territories</h5>
            </div>
            <span className="badge bg-primary rounded-pill">
              {(tab1.selectedTerritoryL1?.length || 0) + (tab1.selectedTerritoryL2?.length || 0)}
            </span>
          </div>

          <div className="row g-2 mb-3">
            <div className="col-6">
            
             
            </div>
            <div className="col-6">
             
             
            </div>
          </div>

          <div className="small text-muted mb-2 fw-semibold">
            {/* {(tab1.selectedTerritoryL1?.length > 0 || tab1.selectedTerritoryL2?.length > 0) ? '\u00A0' : 'All Territories'} */}
          </div>
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {(tab1.territoryCombined || []).map((t, i) => (
                  <div key={`tc_${i}`} className="border-bottom py-1 small text-muted">
                    {t}
                  </div>
                ))}
          </div>
        </div>
      </div>
    </div>

  </div>
)}


      </>)}

           
        </div>
      </div>
    </div>
  );
}